import format from 'date-fns/format'; // tslint:disable-line
import Link from 'gatsby-link';
import React from 'react';
import {
  ContentfulBlogPostConnection,
  ContentfulBlogPostEdge,
} from '../graphql';

interface Props {
  data: {
    posts: ContentfulBlogPostConnection;
  };
}

const IndexPage: React.SFC<Props> = ({ data }) => {
  const groupByDate: {
    [key: string]: ContentfulBlogPostEdge[];
  } = data.posts.edges.reduce<any>((prev, post) => {
    const year = new Date(post.node.fields.publishedDate).getFullYear();

    return { ...prev, [year]: [...(prev[year] || []), post] };
  }, {});

  return (
    <ul className="p-0 list-reset">
      {Object.keys(groupByDate)
        .reverse()
        .map(year => (
          <li key={year}>
            <h2 className="mb-2 leading-normal mt-8">{year}</h2>
            <ul className="mb-2 p-0 list-reset">
              {groupByDate[year].map((post, idx) => (
                <li key={idx} className="mb-2 flex justify-between">
                  <Link className="text-black" to={post.node.fields.url}>
                    {post.node.title}
                  </Link>
                  <span className="text-grey-dark">
                    {format(post.node.fields.publishedDate, 'MMMM D')}
                  </span>
                </li>
              ))}
            </ul>
          </li>
        ))}
    </ul>
  );
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexQuery {
    posts: allContentfulBlogPost(
      sort: { fields: [fields___publishedDate], order: DESC }
    ) {
      edges {
        node {
          title
          fields {
            url
            publishedDate
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.tsx